var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShown)?_c('router-link',{staticClass:"button is-small is-link",attrs:{"to":_vm.goToId}},[_c('b-icon',{attrs:{"icon":"pencil","size":"is-small"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }